/**
 * Export `searchOnInput`.
 */

export function searchOnInput(input: string, option: any) {
  return (option?.searchValue ?? '').toLowerCase().includes(input.toLowerCase());
}
